import { render } from "./SubMenus.vue?vue&type=template&id=36bba264&scoped=true"
import script from "./SubMenus.vue?vue&type=script&lang=js"
export * from "./SubMenus.vue?vue&type=script&lang=js"

import "./SubMenus.vue?vue&type=style&index=0&id=36bba264&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36bba264"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QTd});
